<form
  (ngSubmit)="handleSubmitClick()"
  [formGroup]="form">
  <div class="flex flex-col gap-6 bg-gray-50 p-6">
    <section class="rounded-sm border border-gray-200 bg-white p-6">
      <h5>Konfiguracja zwrotów</h5>

      <div class="mt-6 grid gap-6 lg:grid-cols-2">
        <app-form-control label="Wysyłanie wiadomości o zwrotach za pobranie">
          <p-toggle-switch [formControl]="form.controls.isCodEmailSent" />
        </app-form-control>

        <div class="lg:col-span-2">
          <app-form-control
            label="Adresy e-mail dla wiadomości o zwrotach za pobranie"
            hint="Wprowadź jeden adres e-mail w osobnej linii. Gdy wysyłka wiadomości jest włączona, pole jest wymagane.">
            <textarea
              [formControl]="form.controls.codMessageEmails"
              appPrimengTextarea
              pTextarea
              rows="8"
              placeholder="np. zwroty@twojadomena.pl"></textarea>
          </app-form-control>
        </div>
      </div>
    </section>

    <div class="mt-auto flex justify-end">
      <p-button
        [disabled]="form.invalid"
        appPrimengButton
        label="Zapisz"
        severity="primary"
        type="submit" />
    </div>
  </div>
</form>
